<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button [defaultHref]="'/'"></ion-back-button>
        </ion-buttons>
        <ion-title>
            <div class="flex items-center gap-2 flex-wrap">
                <span>{{ orderCode() || ('cart' | transloco) }}</span>

                <!--<span *ngIf='cartTableName()'> {{ cartTableName() }} </span>-->
            </div>
        </ion-title>

        <div slot="end" class="flex pr-4">
            <button
                *ngIf="versionCode() > 0  && !isCartShared()"
                tuiButton
                (click)="toggleCartQrCodeSheet()"
                appearance="flat"
                size="s"
            >
                <tui-svg slot="icon-only" [src]="'svg::qr-code'"></tui-svg>
            </button>

            <us-share-order-btn />

            <button
                tuiIconButton
                size="s"
                appearance="flat"
                (click)="toggleCartActionsSheet()"
                *ngIf="isCartOwner() && !isCartShared()"
            >
                <tui-svg slot="icon-only" [src]="'svg::ellipsis-vertical'"></tui-svg>
            </button>
        </div>
    </ion-toolbar>
</ion-header>

<ion-content style="--background: #f5f5fa">
    <ng-container *ngIf="orderType() === OrderType.OrderAtTheTable; else deliveryTpl">
        <us-cart-at-the-table></us-cart-at-the-table>
    </ng-container>

    <ng-template #deliveryTpl>
        <us-cart-delivery></us-cart-delivery>
    </ng-template>
</ion-content>

<ng-template
    [tuiSheet]="showActionsSheet()"
    (tuiSheetChange)="showActionsSheet.set($event)"
    [tuiSheetOptions]="options"
>
    <h2 tuiSheetHeading>
        <label>{{'action' | transloco}}</label>
    </h2>

    <us-order-actions [cart]="cart()" [showClearCart]="true" (buttonClick)="toggleCartActionsSheet()">
    </us-order-actions>
</ng-template>

<!-- <ng-template [(tuiSheet)]='showCartQrCodeSheet' [tuiSheetOptions]='options'>
    <h2 tuiSheetHeading>
        <label>{{ 'order_qrcode' | transloco }}</label>
    </h2>


    <div class='text-center' *ngIf='cart$ | async as cart'>
        <us-order-qrcode [order]='cart'></us-order-qrcode>

        <p class='text-xl text-medium font-gray-800'>
            {{cart.order_code}}
        </p>
    </div>

</ng-template> -->
